import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onFocus, ...props }, ref) => {
  const handleFocus = (event) => {
    onFocus?.(event);
    if (!event.defaultPrevented && event.currentTarget.closest("table")) {
      const control = event.currentTarget;
      requestAnimationFrame(() => control.scrollIntoView({ block: "nearest", inline: "nearest" }));
    }
  };
  return (
    <input
      type={type}
      className={cn(
        "flex h-[var(--erp-control-height)] w-full rounded-none border border-input bg-background px-3 py-1 text-base shadow-none transition-colors duration-100 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      onFocus={handleFocus}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
